import _ from '../../common/utility'

// function to inject IFI ad in manual2col bucket (Disease article)
function injectIFIContainerManual2Col() {
    const manual2col = $(".hp_manual2col ul li:nth-child(3)");
    const ifi2ColHtml = `<li><div id="ads-pos-420" class="AdUnit"></div><div id="ads-pos-1420" class="AdUnit"></div></li>`;
    if (manual2col.length > 0) {
        manual2col.after(ifi2ColHtml);
        webmd.ads2.defineAd({
            id: 'ads-pos-420',
            pos: 420
        });
        webmd.ads2.defineAd({
            id: 'ads-pos-1420',
            pos: 1420
        });
    }
}

export default _.catch(injectIFIContainerManual2Col);